/**
 * Converte um gráfico da tela do Comex (evolução) num spec do Gerador de
 * Gráficos, para virar imagem no padrão da casa (604x366, fundo preto,
 * título amarelo, fonte no rodapé). Lá o usuário ainda troca o modelo e
 * ajusta o que quiser antes de gerar o JPG.
 *
 * Os valores vão já divididos pela escala do gráfico (US$ milhões, mil/t…),
 * e a unidade fica no título — como nos gráficos publicados.
 */

const CORES_SERIES = ["#3DAA73", "#F0A32E", "#3F8FE0", "#E34B4B", "#9B7FD4", "#00C2C7", "#F0F000", "#FF7AC8"];

const arredondar = (valor, divisor) => Number(((Number(valor) || 0) / divisor).toFixed(2));

/** Modelo do gerador mais próximo do gráfico da tela. */
function modeloPara(tipoGrafico, multi) {
  if (tipoGrafico === "pie") return "rosca-participacao";
  if (tipoGrafico === "bar") return "coluna-agrupada";
  return multi ? "linha-historica" : "area-evolucao";
}

export function specDoGraficoComex({ dados, titulo, subtitulo, escala, tipoGrafico, cor }) {
  if (!dados) return null;
  const divisor = escala?.divisor || 1;
  const multi = Boolean(dados.multiSeries);
  const modelo = modeloPara(tipoGrafico, multi);

  let categorias;
  let series;
  if (modelo === "rosca-participacao") {
    // Pizza: uma fatia por série (várias) ou por categoria (uma série).
    categorias = multi ? dados.series.map((s) => s.name) : dados.categories || [];
    const valores = multi
      ? dados.series.map((s) => (s.data || []).reduce((a, v) => a + (v || 0), 0))
      : dados.values || [];
    series = [{ nome: titulo, valores: valores.map((v) => arredondar(v, divisor)) }];
  } else if (multi) {
    categorias = dados.categories || [];
    series = dados.series.map((s, i) => ({
      nome: s.name,
      cor: i === 0 && cor ? cor : CORES_SERIES[i % CORES_SERIES.length],
      valores: (s.data || []).map((v) => arredondar(v, divisor)),
    }));
  } else {
    categorias = dados.categories || [];
    series = [{ nome: titulo, cor: cor || CORES_SERIES[0], valores: (dados.values || []).map((v) => arredondar(v, divisor)) }];
  }
  if (!categorias.length || !series.some((s) => s.valores.length)) return null;

  return {
    modelo,
    titulo: [
      { texto: `${titulo} `, cor: "#F0F000" },
      ...(escala?.unidade ? [{ texto: `(${escala.unidade})`, cor: "#FFFFFF", tamanho: 9 }] : []),
    ],
    subtitulo: [{ texto: subtitulo, cor: "#4EA6FF" }],
    fonte: "Fonte: RURAL BUSINESS/ME",
    fundo: "#000000",
    fundoPlot: "nenhum",
    dados: { categorias: categorias.map(String), series },
    legenda: { visivel: multi || modelo === "rosca-participacao" },
    valores: { decimais: 2, prefixo: "", sufixo: "", exibirEm: "todos" },
    rotulo: { corTexto: "#000000", corFundo: "#FFFFFF", corBorda: "#000000" },
    extras: modelo === "area-evolucao" ? { suave: true, opacidadeArea: 0.55 } : {},
  };
}
